export default class SharedCartDialog {
    private copyButton: HTMLInputElement;
    private urlInput: HTMLInputElement;

    init(copyButtonId: string, urlInputId: string): void {
        this.initElements(copyButtonId, urlInputId);
        this.registerListeners();
    }

    private initElements(shareButtonId: string, urlInputId: string): void {
        this.copyButton = <HTMLInputElement>document.getElementById(shareButtonId);
        this.urlInput = <HTMLInputElement>document.getElementById(urlInputId);
    }

    private registerListeners(): void {
        this.copyButton.addEventListener('click', async () => {
            await this.copyUrlToClipboard();
        });
    }

    private copyUrlToClipboard(): void {
        this.urlInput.select();
        this.urlInput.setSelectionRange(0, 99999); //For mobile devices

        var result = document.execCommand('copy');
    }
}
